import { LineChart } from "@mui/x-charts/LineChart";
import { ChartsReferenceLine } from "@mui/x-charts/ChartsReferenceLine";
import { FC } from "react";
import { EPI_CHART_AXIS_TEXT_COLOR, EPI_COLORS } from "./epiColors";
import './EpiLineChart.scss';

interface Props {
	labels: string[];
	values: (number | null)[];
	goal?: number;
	emptyMessage: string;
}

const EpiLineChart: FC<Props> = ({ labels, values, goal, emptyMessage }) => {
	const hasData = values.some(value => value !== null && value !== undefined);

	if (!hasData) {
		return (
			<div className="epi-line-chart epi-line-chart-vazio">
				<span>{emptyMessage}</span>
			</div>
		);
	}

	return (
		<div className="epi-line-chart">
			<LineChart
				xAxis={[{
					scaleType: 'point',
					data: labels,
					tickLabelStyle: { fill: EPI_CHART_AXIS_TEXT_COLOR },
					labelStyle: { fill: EPI_CHART_AXIS_TEXT_COLOR }
				}]}
				yAxis={[{
					min: 0,
					max: 100,
					tickLabelStyle: { fill: EPI_CHART_AXIS_TEXT_COLOR },
					labelStyle: { fill: EPI_CHART_AXIS_TEXT_COLOR }
				}]}
				series={[{
					data: values,
					connectNulls: false,
					color: EPI_COLORS.success,
					valueFormatter: value => value === null ? 'Sem inspeção' : `${value}%`
				}]}
				slotProps={{
					legend: { labelStyle: { fill: EPI_CHART_AXIS_TEXT_COLOR } }
				}}
				height={280}
			>
				{goal !== undefined && (
					<ChartsReferenceLine
						y={goal}
						label={`Meta: ${goal}%`}
						labelStyle={{ fill: EPI_CHART_AXIS_TEXT_COLOR }}
						lineStyle={{ stroke: EPI_CHART_AXIS_TEXT_COLOR, strokeDasharray: '6 4' }}
					/>
				)}
			</LineChart>
		</div>
	);
};

export default EpiLineChart;
